export default "__VITE_ASSET__D$UzaPRg__"